export default __webpack_public_path__ + "static/robotics-04b2084c69111cb7cf120f46b8f42f90.png";